import type { LoggerOptions } from 'pino'
import pino from 'pino'
import type {
  SplunkCollectorArgs,
  OpenSearchGatewayCollectorArgs,
  VtexLogger,
} from '@vtex/diagnostics-core'
import {
  SplunkCollector,
  LoggerOrchestrator,
  PrettyConsole,
  OpenSearchGatewayCollector,
} from '@vtex/diagnostics-core'

export type LoggerConfig = {
  /**
   * @default process.env.NODE_ENV
   */
  mode?: string

  // TODO: better types stripping out the configurations which doesn't work for web
  pino?: LoggerOptions

  splunk?: SplunkCollectorArgs
  openSearch?: OpenSearchGatewayCollectorArgs
}

export const Logger = {
  create({ mode = process.env.NODE_ENV, ...config }: LoggerConfig): VtexLogger {
    if (mode !== 'production') {
      return pino({
        ...config.pino,
        browser: {
          write(object) {
            const formatted = config.pino?.formatters?.log?.(object) ?? object

            PrettyConsole.print(formatted)
          },
        },
      })
    }

    const splunk =
      config.splunk &&
      LoggerOrchestrator.create({
        collector: SplunkCollector.create(config.splunk),
      })

    const openSearch =
      config.openSearch &&
      LoggerOrchestrator.create({
        collector: OpenSearchGatewayCollector.create(config.openSearch),
      })

    const logger = pino({
      ...config.pino,
      browser: {
        write(object) {
          const formatted = config.pino?.formatters?.log?.(object) ?? object

          PrettyConsole.print(formatted)
          splunk?.send(formatted)
          openSearch?.send(formatted)
        },
      },
    })

    // 1. window can be undefined on server-side rendering
    // 2. window.addEventListener can be undefined on react-native environment
    if (typeof window !== 'undefined' && window.addEventListener) {
      if (splunk) {
        window.addEventListener('offline', splunk.pause)
        window.addEventListener('online', splunk.resume)
      }

      if (openSearch) {
        window.addEventListener('offline', openSearch.pause)
        window.addEventListener('online', openSearch.resume)
      }
    }

    return logger
  },
}
